import React, { Component } from 'react';
import './GroupUserListPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import mainAPI from '../../api/MainAPI';
import Button from '../../components/button/Button';
import CardHeader from '../../components/cardHeader/CardHeader';
import EditAgencyPopup from '../../popups/editAgencyPopup/EditAgencyPopup';
import toasts from '../../utils/toasts';
import utils from '../../utils/utils';
import CheckBox from '../../inputs/checkBox/CheckBox';

export const urls = {
	'http://localhost:3000': 'http://localhost:3000',
	'http://localhost:3001': 'http://localhost:3001',
	'https://admin.logrx.com': 'https://app.logrx.com',
	'https://dev-admin.logrx.com': 'https://dev.logrx.com'
};
let adminUrls = {
	'http://localhost:3000': 'http://localhost:3000',
	'http://localhost:3001': 'http://localhost:3001',
	'https://admin.logrx.com': 'https://admin.logrx.com',
	'https://dev-admin.logrx.com': 'https://dev-admin.logrx.com'
};

const categoryOptions = ['Veterinary', 'Law Enforcement', 'Controlled Substance', 'Non-Controlled Substance'];

export default class GroupUserListPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			userGroup: {}
		};
	}

	componentDidMount = async () => {
		await this.getData();
	};

	getData = async () => {
		let users = await mainAPI.user.for_group(this.props.match.params.userGroupId);
		let disabledCategories = await mainAPI.disabled_drug_type_category.all(this.props.match.params.userGroupId);
		let userGroup = await mainAPI.user_group.getAsSuperAdmin({id:this.props.match.params.userGroupId});
		this.setState({ users, disabledCategories, userGroup });
	};

	updateAgency = async (details) => {
		try {
			await mainAPI.user_group.updateMetaData({ id: this.props.match.params.userGroupId, ...details });
			toasts.show('Agency updated');
		} catch (e) {
			toasts.show('Failed to update Agency');
		}
	};

	toggleAgencyOverdueInvoice = async () => {
		try {
			await mainAPI.user_group.updateMetaData({ id: this.props.match.params.userGroupId, has_overdue_invoice:!this.state.userGroup.has_overdue_invoice ? 1:0 });
      await this.getData();
			toasts.show('Agency updated');
		} catch (e) {
			toasts.show('Failed to update Agency');
		}
	};

	togglenarcLock = async (value) => {
		value = value ? 1 : 0;
		const {userGroup: {id: user_group_id} = {}} = this.state
		try {
			await mainAPI.user_group.updateMetaData({ id: user_group_id, narc_lock_integration_enabled: value });
			await this.getData();
			toasts.show('NarcLock updated for Agency');
		} catch (e) {
			toasts.show('Failed to update NarcLock for Agency');
		}
	}

	disableCategory = async (value, categoryName, {id} = {}) => {
		const {match: {params: {userGroupId: user_group_id__manual} = {}} = {params: {}}} = this.props;
		if (value) {
			const {id: deletedId} = await mainAPI.disabled_drug_type_category.delete({id,
				notes: `Deleting "${categoryName}" for user_group_id: ${user_group_id__manual}. id: ${id}`
			});
			if (id === deletedId) toasts.show(`${categoryName} is now enabled`);
			else toasts.show(`Error enabling ${categoryName} category`);
		}
		else {
			const response = await mainAPI.disabled_drug_type_category.create({user_group_id__manual, category_name: categoryName});
			const {category_name, err: {response: {data: {err}}} = {response: {data: {}}}} = response;
			if(category_name) { toasts.show(`${category_name} is now disabled`); }
			else if(err) { toasts.show(err); }
			else { toasts.show('Failed to disable category'); }
		}
		const disabledCategories = await mainAPI.disabled_drug_type_category.all(user_group_id__manual);
		this.setState({ disabledCategories });
	};

	logInAsUser = (user) => {
		const storage = this.getLocalStorageForUser(user);
		window.location = urls[window.location.origin] + '?storage=' + encodeURIComponent(JSON.stringify(storage)) + '#set-storage'
	};

	logInAsAdmin = (user) => {
		localStorage.clear();

		const storage = this.getLocalStorageForUser(user);
		for (let i in storage){
		  localStorage.setItem(i, storage[i])
		}
		window.location = adminUrls[window.location.origin];
	};

	getLocalStorageForUser = (user) => {
		return {
			user_group_id : this.props.match.params.userGroupId,
			token : user.token,
			last_log_in : Date.now(),
			num_additional_groups : 2,
		}
	};


	_renderUsers = () => {
		let display = [];

		for (let i in this.state.users) {
			let user = this.state.users[i];
			display.push(
				<div className="row" key={user.id}>
					<Label black>{user.first_name + ' ' + user.last_name}</Label>
					<Label black>{user.primary_email}</Label>
					<Label black>{utils.capitalizeWords(user.role.replace(/_/g, ' '))}</Label>
					<div className='btn-col'>
						{user.role != 'user' &&

							<Button
								bg="blue"
								color="white"
								onClick={() => {
									this.logInAsAdmin(user);
								}}
							>
								Admin Login
							</Button>

						}
						<Button
							bg="blue"
							color="white"
							onClick={() => {
								this.logInAsUser(user);
							}}
						>
							App Login
						</Button>
					</div>
				</div>
			);
		}
		return display;
	};

	renderEditBtn = () => {
		return (
			<div className="edit-agency-btn">
				<Button
					bg="blue"
					color="white"
					onClick={() => {
						window.popupController.show(EditAgencyPopup, {
							title: 'Edit the Agency name',
							onComplete: (details) => {
								this.updateAgency(details);
							}
						});
					}}
				>
					Edit Agency Name
				</Button>
			</div>
		);
	};

	renderOverduePaymentButton = () => {
    const userGroup = this.state.userGroup || {};
    const text = userGroup.has_overdue_invoice ? 'Set invoice as paid' : 'Set invoice as overdue'
    const bg = userGroup.has_overdue_invoice ? 'blue' : 'red'
		return (
			<div className="overdue-invoice-btn">
				<Button
					bg={bg}
					color="white"
					onClick={this.toggleAgencyOverdueInvoice}
				>
          {text}
				</Button>
			</div>
		);
	};

	_renderCategories = () => {
		let disabledCategories = this.state.disabledCategories;
		let disabledCategoryNames = [];
		let allCategories = [];

		for (let i in disabledCategories) {
			if (disabledCategories[i].category_name) {
				disabledCategoryNames.push(disabledCategories[i].category_name);
			}
		}

		for (let i in categoryOptions) {
			const {id} = (disabledCategories || []).find(({category_name}) => category_name === categoryOptions[i]) || {}
			let iconOrCheckbox = (
				<CheckBox
					value={!disabledCategoryNames.includes(categoryOptions[i])}
					className="is-enabled"
					title="Enabled"
					onChange={(value) => {
						this.disableCategory(value, categoryOptions[i], {id});
					}}
				/>
			);

			allCategories.push(
				<div className="checkbox-row" key={allCategories}>
					{iconOrCheckbox}
					<Label black>{categoryOptions[i]}</Label>
				</div>
			);
		}
		return allCategories;
	};

	_renderIntegrations = () => {
		const {userGroup: {narc_lock_integration_enabled: narcLockEnabled = false} = {}} = this.state
		return (<>
			<Label className="settings-header" black large>Integrations</Label>
			<div className="checkbox-row" key="narc-lock-integration">
				<CheckBox value={!!narcLockEnabled} className="is-enabled" title="Enabled" onChange={this.togglenarcLock}/>
				<Label black>NarcLock</Label>
			</div>
		</>);
	}

	render() {
		return (
			<Page className="g-group-user-list-page">
				{this.renderEditBtn()}
				{this.renderOverduePaymentButton()}
				<Card>
					<div className="top-row">
						<CardHeader>{this.state.userGroup && this.state.userGroup.name} Users</CardHeader>
					</div>
					{this._renderUsers()}
				</Card>
				<Card>
					<div className="top-row"><CardHeader className="account-settings">Super Admin Account Settings</CardHeader></div>
					<Label className="settings-header" black large>Drug Categories</Label>
					{this._renderCategories()}
					{this._renderIntegrations()}
				</Card>
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/groupUserListPage/GroupUserListPage.jsx